"use client";

import React from "react";
import { NodeViewWrapper } from "@tiptap/react";

interface ImageNodeFrontendProps {
  node: any;
}

export function ImageNodeFrontend({ node }: ImageNodeFrontendProps) {
  const { src, alt, caption, size, transparent } = node.attrs;

  const transparentClass = transparent ? " tiptap-image-transparent" : "";
  const dataTransparent = transparent ? "true" : undefined;

  // If no caption, render simple image
  if (!caption) {
    return (
      <NodeViewWrapper>
        <div
          className={`node-image image-wrapper tiptap-image-${size || "large"}${transparentClass}`}
          data-transparent={dataTransparent}
        >
          <img
            src={src}
            alt={alt || ""}
            className={`tiptap-image tiptap-image-${size || "large"}${transparentClass}`}
            data-size={size || "large"}
            data-transparent={dataTransparent}
          />
        </div>
      </NodeViewWrapper>
    );
  }

  // With caption, render with caption below
  return (
    <NodeViewWrapper>
      <div
        className={`node-image image-wrapper tiptap-image-${size || "large"}${transparentClass}`}
        data-transparent={dataTransparent}
      >
        <img
          src={src}
          alt={alt || ""}
          className={`tiptap-image tiptap-image-${size || "large"}${transparentClass}`}
          data-size={size || "large"}
          data-transparent={dataTransparent}
        />
        <p className="image-caption">{caption}</p>
      </div>
    </NodeViewWrapper>
  );
}

